import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      neededAuth: true,
      name: 'Ínicio'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue'),
    meta: {
      neededAuth: true,
      name: 'Sobre nós'
    }
  },
  {
    path: '/clientes',
    name: 'clients',
    component: () => import('../views/Clients.vue'),
    meta: {
      neededAuth: true,
      name: 'Clientes'
    }
  },
  {
    path: '/caixa',
    name: 'register',
    component: () => import('../views/CashFluxByDay.vue'),
    meta: {
      neededAuth: true,
      name: 'Caixa por data'
    }
  },
  {
    path: '/caixa/fluxo',
    name: 'registerflux',
    component: () => import('../views/CashFlux.vue'),
    meta: {
      neededAuth: true,
      name: 'Fluxo de caixa'
    }
  },
  {
    path: '/dashboard/faturamento',
    name: 'cashdashboard',
    component: () => import('../views/DashboardFaturamento.vue'),
    meta: {
      neededAuth: true,
      name: 'Dashboard de faturamento'
    }
  },
  {
    path: '/dashboard/financeiro',
    name: 'registerdashboard',
    component: () => import('../views/DashboardFinanceiro.vue'),
    meta: {
      neededAuth: true,
      name: 'Dashboard financeiro'
    }
  },
  {
    path: '/relatorios/finan/contasreceber/:id',
    name: 'billstoreceive',
    component: () => import('../views/reports/finan/billsToReceive.vue'),
    meta: {
      neededAuth: true,
      name: 'Relatorios financeiros de contas a receber'
    }
  },
  {
    path: '/relatorios/finan/contaspagar/:id',
    name: 'billstopay',
    component: () => import('../views/reports/finan/billsToPay.vue'),
    meta: {
      neededAuth: true,
      name: 'Relatorios financeiros de contas a pagar'
    }
  },
  {
    path: '/mesas',
    name: 'mesas',
    component: () => import('../views/mesas/index.vue'),
    meta: {
      neededAuth: true,
      name: 'Informações das mesas'
    },
    children: [
      {
        path: '/mesas/mapa',
        name: 'mesas.mapa',
        component: () => import('../views/mesas/mapa.vue'),
        meta: {
          name: 'Mapa de mesas',
          neededAuth: true
        }
      },
      {
        path: '/mesas/mapa/:id',
        name: 'mesas.mapa.index',
        component: () => import('../views/mesas/detalhe.vue'),
        meta: {
          name: 'Mapa de mesas (Detalhe)',
          neededAuth: true
        }
      }
    ]
  },
  {
    path: '/movimento-financeiro/',
    name: 'financialMoviment',
    component: () => import('../views/financialMoviment/index.vue'),
    meta: {
      neededAuth: true,
      name: 'Movimento Financeiro'
    },
    children: [
      {
        path: '/movimento-financeiro/contas-pagar',
        name: 'movimentToPay',
        component: () => import('../views/financialMoviment/toPay.vue'),
        meta: {
          name: 'Contas a pagar',
          neededAuth: true
        }
      },
      {
        path: '/movimento-financeiro/nova-conta-pagar',
        name: 'newMovimentToPay',
        component: () => import('../views/financialMoviment/newPay.vue'),
        meta: {
          name: 'Nova conta a pagar',
          neededAuth: true
        }
      },
      {
        path: '/movimento-financeiro/contas-receber',
        name: 'movimentToReceive',
        component: () => import('../views/financialMoviment/toReceive.vue'),
        meta: {
          name: 'Contas a receber',
          neededAuth: true
        }
      },
      {
        path: '/movimento-financeiro/nova-conta-receber',
        name: 'newMovimentToReceive',
        component: () => import('../views/financialMoviment/newReceive.vue'),
        meta: {
          name: 'Nova conta a receber',
          neededAuth: true
        }
      },
    ]
  },
  {
    path: '/estoque',
    name: 'estoque',
    component: () => import('../views/estoque/produtos/index.vue'),
    meta: {
      neededAuth: true,
      name: 'Estoque'
    },
    children: [
      {
        path: '/estoque/produtos',
        name: 'produtos',
        component: () => import('../views/estoque/produtos/index.vue'),
        meta: {
          neededAuth: true,
          name: 'Produtos'
        },
        children: [
          {
            path: '/estoque/produtos',
            name: 'produtos.todos',
            component: () => import('../views/estoque/produtos/produtos.vue'),
            meta: {
              neededAuth: true,
              name: 'Estoque'
            }
          },
          {
            path: '/estoque/produtos/novo',
            name: 'produtos.novo',
            component: () => import('../views/estoque/produtos/novo.vue'),
            meta: {
              neededAuth: true,
              name: 'Novo Produto'
            }
          },
          {
            path: '/estoque/produtos/:id',
            name: 'produtos.editar',
            component: () => import('../views/estoque/produtos/editar.vue'),
            meta: {
              neededAuth: true,
              name: 'Editar Produto'
            }
          },
        ]
      },
      {
        path: '/estoque/grupos',
        name: 'grupos',
        component: () => import('../views/estoque/grupos/index.vue'),
        meta: {
          neededAuth: true,
          name: 'Grupos'
        },
        children: [
          {
            path: '/estoque/grupos/novo',
            name: 'grupos.novo',
            component: () => import('../views/estoque/grupos/novo.vue'),
            meta: {
              neededAuth: true,
              name: 'Novo Grupo'
            }
          },
          {
            path: '/estoque/grupos',
            name: 'grupos.todos',
            component: () => import('../views/estoque/grupos/grupo.vue'),
            meta: {
              neededAuth: true,
              name: 'Grupos'
            }
          },
          {
            path: '/estoque/grupos/:id',
            name: 'grupos.editar',
            component: () => import('../views/estoque/grupos/editar.vue'),
            meta: {
              neededAuth: true,
              name: 'Editar Grupo'
            }
          },
        ]
      },
      {
        path: '/estoque/subgrupos',
        name: 'subgrupos',
        component: () => import('../views/estoque/subgrupos/index.vue'),
        meta: {
          neededAuth: true,
          name: 'Sub Grupos'
        },
        children: [
          {
            path: '/estoque/sub-grupos',
            name: 'subgrupo.todos',
            component: () => import('../views/estoque/subgrupos/subgrupo.vue'),
            meta: {
              neededAuth: true,
              name: 'Sub Grupos'
            }
          },
          {
            path: '/estoque/sub-grupos/novo',
            name: 'subgrupo.novo',
            component: () => import('../views/estoque/subgrupos/novo.vue'),
            meta: {
              neededAuth: true,
              name: 'Novo Sub-Grupo'
            }
          },
          {
            path: '/estoque/sub-grupos/:id',
            name: 'subgrupo.editar',
            component: () => import('../views/estoque/subgrupos/editar.vue'),
            meta: {
              neededAuth: true,
              name: 'Editar Sub-Grupo'
            }
          },
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// eslint-disable-next-line
router.afterEach((to, from, next) => {
  // console.log('Client width', '=>', window.innerWidth)
  if(window.innerWidth < 990){
    let menu = document.getElementById('app-body')
    menu.classList.toggle('sb-sidenav-toggled')
  }
  // }
//   let data = JSON.parse(localStorage.getItem('gestor-board'))

//   let auth = async function(){
//     if(data == null){
//       return false
//     }else{
//       if(
//           data.logged != null || data.logged == true ||  
//           data.user.token != null || data.user.token != ''
//         ){
//         let response = await fetch(server +  'isauth?token=' + data.user.token, {
//           method: 'POST'
//         })
    
//         let responseJSON = await response.json()
        
//         return responseJSON.data
//       }else{
//         return false
//       }
//     }
//   }

//   // eslint-disale-next-line
//   auth().then(response => {
//     if(to.matched.some(record => record.meta.neededAuth)){
//       if(true){
//         next()
//       }else{
//         next({name: 'login'})
//       }
//     }else{
//       next()
//     }
//   })
})

export default router
